import { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProfileView from "@/components/ProfileView";
import { Loader2 } from "lucide-react";

export default function PublicProfile() {
  const { username } = useParams();
  const [data, setData] = useState(null);
  const [state, setState] = useState("loading");
  const fetchedRef = useRef(null);

  useEffect(() => {
    if (fetchedRef.current === username) return;
    fetchedRef.current = username;
    (async () => {
      try {
        const res = await api.get(`/profile/${encodeURIComponent(username)}`);
        setData(res.data);
        setState("ok");
      } catch {
        setState("notfound");
      }
    })();
  }, [username]);

  if (state === "loading")
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 text-violet-500 animate-spin" />
      </div>
    );

  if (state === "notfound")
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background text-center px-4">
        <div className="absolute inset-0 radial-violet pointer-events-none" />
        <h1 className="relative font-serif font-bold text-6xl text-white mb-2">404</h1>
        <p className="relative text-zinc-400 mb-6">grime.bio/{username} isn't claimed yet.</p>
        <Link to={`/register?u=${encodeURIComponent(username)}`} className="relative bg-violet-600 hover:bg-violet-500 text-white rounded-full px-6 py-2.5 text-sm font-medium transition-colors" data-testid="claim-this-link">
          Claim this username
        </Link>
      </div>
    );

  return <ProfileView profile={data.profile} username={data.username} views={data.views} />;
}
